
import React, { useState } from 'react';
import { supabase } from '../../supabaseClient';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);

            
            const { data: authData, error: authError } = await supabase.auth.signInWithPassword({ email, password });
            if (authError) throw authError;

            // 사용자 정보 조회
            const { data: userData, error: userError } = await supabase
                .from('users')
                .select('id, email')
                .eq('id', authData.user.id)
                .eq('is_admin', true)
                .maybeSingle();
            
            if (userError || !userData) {
                await supabase.auth.signOut();
                localStorage.removeItem('isAdmin');
                localStorage.removeItem('userId');
                localStorage.removeItem('userInfoId');
                localStorage.removeItem('nickname');
                throw new Error('관리자만 로그인할 수 있습니다.');
            }

            // user_info에서 관리자 여부 확인
            const { data: userInfoData, error: userInfoError } = await supabase
                .from('user_info')
                .select('adm_yn, user_info_id, nickname')
                .eq('user_id', userData.id)
                .eq('adm_yn', 'Y') // 관리자 여부 확인
                .maybeSingle(); // single() 대신 maybeSingle()로 변경

            console.log('user_info 조회 결과:', { userInfoData, userInfoError });

            // 관리자가 아니면 로그인 불가
            if (!userInfoData) {
                await supabase.auth.signOut();
                localStorage.removeItem('isAdmin');
                localStorage.removeItem('userId');
                localStorage.removeItem('userInfoId');
                localStorage.removeItem('nickname');
                throw new Error('관리자만 로그인할 수 있습니다.');
                
            }

            // 관리자 여부 저장
            const isAdmin = userInfoData?.adm_yn === 'Y';
            localStorage.setItem('isAdmin', isAdmin ? 'true' : 'false');
            localStorage.setItem('userId', userData.id);
            localStorage.setItem('userInfoId', userInfoData.user_info_id || '');
            localStorage.setItem('nickname', userInfoData.nickname || '');
            
            console.log('로그인 정보 저장:', { 
                userInfoId: userInfoData?.user_info_id, 
                nickname: userInfoData?.nickname,
                isAdmin 
            });
            
            // 로그인 성공 후 리다이렉트 (약간의 딜레이 추가)
            setTimeout(() => {
                window.location.href = '/';
            }, 500);

            // The parent App component will handle the redirect on session change.
        } catch (error) {
            alert(error.error_description || error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xl-10 col-lg-12 col-md-9">
                    <div className="card o-hidden border-0 shadow-lg my-5">
                        <div className="card-body p-0">
                            <div className="row">
                                <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                                <div className="col-lg-6">
                                    <div className="p-5">
                                        <div className="text-center">
                                            <h1 className="h4 text-gray-900 mb-4">Welcome Back!</h1>
                                        </div>
                                        <form className="user" onSubmit={handleLogin}>
                                            <div className="form-group">
                                                <input
                                                    type="email"
                                                    className="form-control form-control-user"
                                                    placeholder="Enter Email Address..."
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="password"
                                                    className="form-control form-control-user"
                                                    placeholder="Password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                            </div>
                                            <button type="submit" className="btn btn-primary btn-user btn-block" disabled={loading}>
                                                {loading ? 'Logging in...' : 'Login'}
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};



export default Login;
